import React, { useState } from 'react';
import { NtIcon } from '../NotionUI';
import { useLanguage } from '../../i18n/LanguageContext';

/**
 * Pulsante "Nuova attività" con menu: accanto all'attività vuota ci sono i
 * modelli di riga del progetto (da applicare, rinominare o eliminare).
 */
function NewTaskSplit({ templates, onNew, onApply, onRename, onDelete }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  return (
    <span className="pv-tab-wrap pd-split">
      <button className="btn pd-split-main" type="button" onClick={() => onNew()}>{t('projectDetail.newTask')}</button>
      <button className="btn pd-split-caret" type="button" aria-label={t('projectDetail.rowTemplates')} aria-expanded={open} onClick={() => setOpen(true)}>▾</button>
      {open && (
        <>
          <div className="pd-overlay" onClick={() => setOpen(false)} />
          <div className="pd-popover pv-menu pd-split-menu">
            <button type="button" className="pv-menu-item" onClick={() => { setOpen(false); onNew(); }}>
              <NtIcon name="plus" /> {t('projectDetail.emptyTask')}
            </button>
            {templates.length > 0 && <div className="pd-popover-label">{t('projectDetail.rowTemplates')}</div>}
            {templates.map((template) => (
              <div key={template.id} className="pd-template-row">
                <button type="button" className="pv-menu-item" onClick={() => { setOpen(false); onApply(template); }}>
                  <NtIcon name="layout" /> {template.name}
                </button>
                <button type="button" className="pd-row-delete" style={{ opacity: 1 }} aria-label={t('projectDetail.renameTemplate')} title={t('projectDetail.renameTemplate')} onClick={() => { setOpen(false); onRename(template); }}><NtIcon name="edit" /></button>
                <button type="button" className="pd-row-delete" style={{ opacity: 1 }} aria-label={t('projectDetail.deleteTemplate')} title={t('projectDetail.deleteTemplate')} onClick={() => { setOpen(false); onDelete(template); }}>×</button>
              </div>
            ))}
            {templates.length === 0 && <p className="nt-muted pd-popover-hint">{t('projectDetail.noTemplatesHint')}</p>}
          </div>
        </>
      )}
    </span>
  );
}

export default NewTaskSplit;
